import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { userSelector } from '../../../redux/selectors/Account';
import LoadingScreen from '../../../screens/LoadingScreen';
import auth from '../../../services/auth';
import { setUserData, setNexwayState, setRealm, setIncludesDefault } from '../../../redux/actions/Account';
import parentPaths from '../../../services/paths';

function Auth({ children }) {
  const user = useSelector(userSelector);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.isSignedIn() && !user) {
      const { currentRealm, pathRealm } = parentPaths.config;

      // eslint-disable-next-line camelcase
      const access_token = auth.getAccessToken();
      dispatch(setUserData(access_token));
      dispatch(setRealm(currentRealm));

      const localNxState = JSON.parse(localStorage.getItem('nexwayState'));
      const localIncludesDefault = JSON.parse(localStorage.getItem('includesDefault'));

      dispatch(setNexwayState(localNxState));
      dispatch(setIncludesDefault(localIncludesDefault));

      currentRealm !== pathRealm && window.location.pathname.replace(`/${pathRealm}`, `/${currentRealm}`);
    }

    setLoading(false);
  }, [dispatch, history, user]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any,
};

export default Auth;
